import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FilterPillsContainer from '../Components/FilterPillsContainer';
import { submitSearchFacet } from '../Actions/FacetedSearch.action';
import { setCookie, getCookie } from './CookieHandler';
import { translate } from '../Services/translation';

const StickyFilter = () => {
    const dispatch = useDispatch();
    const facetedSearch = useSelector(state => state.facetedSearch);
    const [stickyFilter, setStickyFilter] = useState(
        getCookie('stickyfilterquery'),
    );

    const params = new URLSearchParams(window.location.search);
    let stickyFilterJson;

    const completeFilter = stickyFilterToComplete => {
        facetedSearch.facetFilters.forEach(facetFilter => {
            let selectedStickyFilter = stickyFilterToComplete.find(
                selected => selected.id === facetFilter.id,
            );

            if (selectedStickyFilter) {
                if (!facetFilter.isSlider) {
                    let validSelectedOptions = selectedStickyFilter.selectedOptions.filter(
                        selectedOption =>
                            facetFilter.options.filter(
                                option => option.id == selectedOption,
                            ).length > 0,
                    );

                    facetFilter.selectedOptions = validSelectedOptions;
                } else {
                    facetFilter.selectedOptions =
                        selectedStickyFilter.selectedOptions;
                }
            }
        });

        return facetedSearch.facetFilters;
    };

    if (stickyFilter) {
        stickyFilterJson = JSON.parse(decodeURIComponent(stickyFilter));
    }

    const applyStickyFilter = () => {
        let stickyFilterJson = JSON.parse(
            decodeURIComponent(getCookie('stickyfilterquery')),
        );
        dispatch(submitSearchFacet(completeFilter(stickyFilterJson)));
    };

    const removeFilter = () => {
        setCookie('stickyfilterquery', '');
        setStickyFilter('');
    };

    return (
        stickyFilterJson?.length > 0 &&
        params?.size === 0 && (
            <>
                <div className="c-usedfilter__head">
                    <h2>{translate('stickyfilter.header')}</h2>
                    <button className="close-button" onClick={removeFilter}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-x-lg"
                            viewBox="0 0 16 16"
                        >
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"></path>
                        </svg>
                    </button>
                </div>
                <div className="c-usedfilter__body">
                    <FilterPillsContainer
                        stickyFilter={stickyFilterJson}
                        stickyFilterDisplay={true}
                    />
                </div>
                <div className="c-usedfilter__footer">
                    <button className="btn-black" onClick={applyStickyFilter}>
                        {translate('stickyfilter.withfilter')}
                    </button>
                    <button className="clear button" onClick={removeFilter}>
                        {translate('stickyfilter.withoutfilter')}
                    </button>
                </div>
            </>
        )
    );
};

export default StickyFilter;
